import React, { useState, useEffect } from "react";
import Design from "./Design";
import {
  fetchTopDetails,
  fetchTopWeeklyEvents,
  fetchUserGiftsTop,
  fetchUserGiftsTopHours,
  RoleEvent,
  SenderGiftTop,
} from "../../services/newEventApi";
const NewEvents = () => {
  const [roleEventData, setRoleEventData] = useState(null);
  const [topWeeklyData, setTopWeeklyData] = useState(null);
  const [userGiftsTopHours, setUserGiftsTopHours] = useState(null);
  const [userGiftsTop, setUserGiftsTop] = useState(null);
  const [topDetails, setTopDetails] = useState(null);
  const [senderGiftTop, setSenderGiftTop] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        // Call the first API
        const topWeeklyRes = await fetchTopWeeklyEvents();

        // Check for success — adjust this condition based on your API structure
        if (
          topWeeklyRes?.success ||
          topWeeklyRes?.status === 200 ||
          topWeeklyRes?.data
        ) {
          // Set the first response
          setTopWeeklyData(topWeeklyRes.data);

          // Call the other endpoints
          const [senderRes, hoursRes, giftsRes, detailsRes, roleRes] =
            await Promise.all([
              SenderGiftTop(),
              fetchUserGiftsTopHours(),
              fetchUserGiftsTop(),
              fetchTopDetails(),
              RoleEvent(),
            ]);

          setSenderGiftTop(senderRes.data);
          setUserGiftsTopHours(hoursRes.data);
          setUserGiftsTop(giftsRes.data);
          setTopDetails(detailsRes.data);
          setRoleEventData(roleRes.data);
        } else {
          setError("Failed to fetch top weekly events");
        }
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <div>
      <Design
        roleEventData={roleEventData}
        topWeeklyData={topWeeklyData}
        userGiftsTopHours={userGiftsTopHours}
        userGiftsTop={userGiftsTop}
        topDetails={topDetails}
        senderGiftTop={senderGiftTop}
      />
    </div>
  );
};

export default NewEvents;
// there is two end points want to replace them
// structure of image
// token
//responsive
